import { gql, useQuery } from "@apollo/client";
import React from "react";
import { useLocation } from "react-router-dom";
import { marketsQuery } from "../../data";
import { extractLocale, getMarketFromLanguage, getMarketFromLocale, getMarketFromLocation, guessMarketFromLanguages, } from "../../helpers/market";
import { generateUrl } from "../../helpers/url";
import MarketContext from "./MarketContext";
export var ApiRegion;
(function (ApiRegion) {
    ApiRegion["Global"] = "global";
    ApiRegion["China"] = "china";
})(ApiRegion || (ApiRegion = {}));
export var MarketRegion;
(function (MarketRegion) {
    MarketRegion["NorthAmerica"] = "North America";
    MarketRegion["AsiaPacific"] = "Asia-Pacific";
    MarketRegion["Europe"] = "Europe";
    MarketRegion["MiddleEast"] = "Middle-East";
    MarketRegion["Global"] = "Global";
})(MarketRegion || (MarketRegion = {}));
export var Features;
(function (Features) {
    Features["EnableLogin"] = "enableLogin";
})(Features || (Features = {}));
export var MarketType;
(function (MarketType) {
    MarketType["Importer"] = "Importer";
    MarketType["PSU"] = "PSU";
    MarketType["SPSU"] = "S-PSU";
})(MarketType || (MarketType = {}));
export const query = () => gql `{
  ${marketsQuery()}
}`;
const MarketProvider = (props) => {
    let availableMarkets = [];
    let queryStatus = {
        loading: true,
        error: false,
    };
    // First check if we have static markets data
    if (props.availableMarkets) {
        availableMarkets = props.availableMarkets;
        queryStatus = {
            loading: false,
            error: false,
        };
    }
    else {
        // Create an empty apollo options object
        const apolloOptions = {};
        // Set custom client if available
        // Use client from context otherwise
        if (props.client) {
            apolloOptions.client = props.client;
        }
        // Set custom context if available
        if (props.queryContext) {
            apolloOptions.context = props.queryContext;
        }
        const { data, error, loading } = useQuery(query(), apolloOptions);
        if (error) {
            queryStatus = {
                error: error.message,
                loading: false,
            };
            availableMarkets = [];
        }
        else if (!loading) {
            queryStatus = {
                error: false,
                loading: false,
            };
            availableMarkets = data.markets;
        }
    }
    let currentMarket;
    let locale;
    if (props.currentMarket) {
        currentMarket = props.currentMarket;
        locale = props.currentMarket.locale;
    }
    else {
        const pathname = useLocation().pathname;
        currentMarket = getMarketFromLocation(availableMarkets, pathname);
        locale = extractLocale(pathname);
    }
    const context = {
        loading: queryStatus.loading,
        error: queryStatus.error,
        currentMarket,
        availableMarkets,
        generateUrl: (path, parameters = {}) => 
        // Generate url with markets information in it
        generateUrl(path, {
            locale,
            ...parameters,
        }),
        getMarketFromLanguage: (languageCode) => getMarketFromLanguage(availableMarkets, languageCode),
        getMarketFromLocale: (locale) => getMarketFromLocale(availableMarkets, locale),
        getMarketFromLocation: (pathname) => getMarketFromLocation(availableMarkets, pathname),
        guessMarketFromLanguages: (languages = []) => guessMarketFromLanguages(availableMarkets, languages),
    };
    return (React.createElement(MarketContext.Provider, { ...props, value: context }, props.children));
};
export default MarketProvider;
